import { SyncQueueStatus } from "@home-health-notify/models";

export const SYNC_QUEUE_STATUS_LABEL: Record<SyncQueueStatus, string> = {
  pending: "Pending",
  added: "Added",
  skipped: "Skipped",
  error: "Error",
  rejected: "Rejected",
  blocked_on_mapping: "Blocked on Mapping",
};

export const SYNC_QUEUE_STATUS_ORDER: SyncQueueStatus[] = [
  "pending",
  "added",
  "skipped",
  "error",
  "rejected",
  "blocked_on_mapping",
];
